import { RefiHttpClient } from '@cof/refi-web-sdk';
import { DebugService } from './debug.service.js';
import { stratum } from '../../../constants/stratum.js';
import { REFI_CREDITPULL_CONST } from '../constants/app.constants.js';

class _ExperimentService {
  constructor() {
    this.debug = new DebugService('ExperimentService');
    this.http = new RefiHttpClient();
    this._experiments = [];
    this._isIconicInvisiblePrequalAndToggledOn = false;
    this._isIconicHardpullAndToggledOn = false;
    this._isCombinedHardpullContractToggledOn = false;
    this._isDelayedHardpullToggledOn = false;
    this._isIconicV2 = false;
    this._isOtp = false;
    this.abTest = null;
    this._abTests = {
      name: '',
      variationIds: [],
      testGroup: '',
      testWeight: 1,
    };
  }

  updateExperiments(newExperiments, removeExperiments = []) {
    stratum.endAbTest(this.abTest);
    const newlyAddedExperiments = newExperiments.map((experiment) =>
      experiment.toLowerCase()
    );
    const updatedExperiments = this._experiments.filter(
      (experiment) => !removeExperiments.includes(experiment)
    );
    this._experiments = Array.from(
      new Set(updatedExperiments.concat(newlyAddedExperiments))
    );
    this._abTests.variationIds = this._experiments;
    this.abTest = stratum.startAbTest(this._abTests);
  }

  setupHardpullAbTests() {
    this.abTestsName = 'hardpull-ab-tests';
    this.updateExperiments([], [REFI_CREDITPULL_CONST.ICONIC_INVISIBLE_PQ]);
  }

  get experiments() {
    return this._experiments;
  }

  set experiments(experiments) {
    this._experiments = experiments;
  }

  set abTestsName(name) {
    this._abTests.name = name;
  }

  get abTestsName() {
    return this._abTests.name;
  }

  get abTestsVariationIds() {
    return this._abTests.variationIds;
  }

  set abTestsVariationIds(ids) {
    this._abTests.variationIds = ids;
  }

  get isIconicInvisiblePrequalAndToggledOn() {
    return this._isIconicInvisiblePrequalAndToggledOn;
  }

  set isIconicInvisiblePrequalAndToggledOn(isIconicInvisiblePrequal) {
    this._isIconicInvisiblePrequalAndToggledOn = isIconicInvisiblePrequal;
  }

  get isIconicHardpullAndToggledOn() {
    return this._isIconicHardpullAndToggledOn;
  }

  set isIconicHardpullAndToggledOn(isIconicHardpull) {
    this._isIconicHardpullAndToggledOn = isIconicHardpull;
  }

  get isIconicV2ToggledOn() {
    return this._isIconicV2;
  }

  set isIconicV2ToggledOn(isIconicV2) {
    this._isIconicV2 = isIconicV2;
  }

  get isCombinedHardpullContractToggledOn() {
    return this._isCombinedHardpullContractToggledOn;
  }

  set isCombinedHardpullContractToggledOn(isCombinedHardpullContract) {
    this._isCombinedHardpullContractToggledOn = isCombinedHardpullContract;
  }

  get isDelayedHardpullToggledOn() {
    return this._isDelayedHardpullToggledOn;
  }

  set isDelayedHardpullToggledOn(isDelayedHardpullToggledOn) {
    this._isDelayedHardpullToggledOn = isDelayedHardpullToggledOn;
  }

  get isOtp() {
    return this._experiments.includes('one-time-passcode');
  }
}
export const ExperimentService = new _ExperimentService();
